import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  Updatecomapny,
  adminComapnyGetByid,
  comapnyGetByid,
  comapnyListService,
  companyAdminStatus,
  companyDelete,
  companyStatus,
  deletecomapny,
  updateCompanydetails,
} from "../../Api/services/companyService";

const comapnaySlice = createSlice({
  name: "Company",
  initialState: {
    companyData: [],
    adminCompanyData: [],
    companySingleData: "hello",
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    //company list data
    builder
      .addCase(comapnyListService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(comapnyListService.fulfilled, (state, action) => {
        console.log(action.payload, "action");
        if (action?.payload?.success === false) {
          console.log(action.payload, "false");
          toast.error("error login");
        } else {
          //   toast.success("get data successfuly");
        }
        return {
          ...state,
          companyData: action.payload,
          loading: false,
        };
      })
      .addCase(comapnyListService.rejected, (state, action) => {
        console.log(action.payload, "action");
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get admin company list
    builder
      .addCase(adminComapnyGetByid.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(adminComapnyGetByid.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          adminCompanyData: action.payload,
          loading: false,
        };
      })
      .addCase(adminComapnyGetByid.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //company by id

    builder
      .addCase(comapnyGetByid.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(comapnyGetByid.fulfilled, (state, action) => {
        console.log(action.payload, "action");
        if (action?.payload?.success === false) {
          console.log(action.payload, "false");
          toast.error("error login");
        } else {
          //   toast.success("get data successfuly");
        }
        return {
          ...state,
          companySingleData: action.payload,
          loading: false,
        };
      })
      .addCase(comapnyGetByid.rejected, (state, action) => {
        console.log(action.payload, "action");
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update api call

    builder
      .addCase(Updatecomapny.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(Updatecomapny.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          console.log(action.payload, "false");
          toast.error("error login");
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          //companySingleData: action.payload,
          loading: false,
        };
      })
      .addCase(Updatecomapny.rejected, (state, action) => {
        console.log(action.payload, "action");
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update company status
    builder
      .addCase(companyStatus.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(companyStatus.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(companyStatus.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update company admin status
    builder
      .addCase(companyAdminStatus.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(companyAdminStatus.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(companyAdminStatus.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //delete company

    builder
      .addCase(deletecomapny.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deletecomapny.fulfilled, (state, action) => {
        console.log(action.payload, "action");
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deletecomapny.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update company data from company pages
    builder
      .addCase(updateCompanydetails.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateCompanydetails.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          //companySingleData: action.payload,
          loading: false,
        };
      })
      .addCase(updateCompanydetails.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //delete whole company
    builder
      .addCase(companyDelete.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(companyDelete.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(companyDelete.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export default comapnaySlice.reducer;
